export enum RoleType {
    ADMIN = 'ADMIN',
    SUPER_USER = 'SUPER_USER',
    SALES_MANAGER = 'SALES_MANAGER',
    SALES_USER = 'SALES_USER',
    TECH_MANAGER = 'TECH_MANAGER',
    TECH_USER = 'TECH_USER',
    TECH_SALES_USER = 'TECH_SALES_USER',
    TECH_SALES_USER_LIGHT = 'TECH_SALES_USER_LIGHT',
    VIEW_ONLY_USER = 'VIEW_ONLY_USER',
    AUDITOR = 'AUDITOR',
    NO_ACCESS = 'NO_ACCESS',
}
